		 					
				import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class AgreementMasterService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('AgreementMaster');
	}
	
	loadAll() : Observable<TooBig4Car.Logic.AgreementMaster[]> {
		return this.myBaseService.loadAll(this.url);
	}
	save(tempItem: TooBig4Car.Logic.AgreementMaster) : Observable<TooBig4Car.Logic.AgreementMaster> {
		return this.myBaseService.save(tempItem, this.url);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<TooBig4Car.Logic.AgreementMaster> {
		return this.myBaseService.getEdit(id, this.url);
	}
	get(id: System.Guid) : Observable<TooBig4Car.Logic.AgreementMaster>{
		return this.myBaseService.get(id, this.url);
	}
	publish(id: System.Guid): Observable<TooBig4Car.Logic.AgreementMaster> {
		return this.myBaseService.post(null, this.url + '/Publish/' + id, true);
	}
}
				
